// import styles from "./ThemeMenu.module.scss";
import _ from 'lodash';
import React, { useState, useEffect } from 'react';
import styles from './ThemeMenu.module.scss';

import { ActionLink } from '../ActionLink';

// TODO embed, until then copy to api when changed
const options = [
  ['theme-radio-classic', 'classic'],
  ['theme-radio-lustrous', 'lustrous'],
  ['theme-radio-blue-peach', 'blue'],
  ['theme-radio-gentle', 'gentle'],
  ['theme-radio-white', 'white'],
  ['theme-radio-zesty', 'zesty'],
  ['theme-radio-delicate', 'delicate'],
  ['theme-radio-pink-blue', 'pink'],
  ['theme-radio-enchanting', 'enchanting'],
  ['theme-radio-beloved', 'beloved'],
  ['theme-radio-earthy', 'earthy'],
  ['theme-radio-purple-grey', 'violet'],
  ['theme-radio-elegant', 'elegant'],
  ['theme-radio-navy-gold', 'navy'],
  ['theme-radio-rustic', 'rustic'],
  ['theme-radio-artistic', 'artistic'],
  ['theme-radio-fun', 'fun'],
];

export interface ThemeMenuProps {
  themeOnly?: boolean;
  theme: string;
  left: number;
  edit_gallery_url: string;
  onPick: (theme: string) => () => void;
  onClickHamburger: () => void;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
  onScrollSlow: () => void;
  onScrollMedium: () => void;
  onScrollFast: () => void;
  speed: string;
  canChangeSpeed: boolean;
}

export interface ThemeOptionProps {
  id: string;
  value: string;
  checked: boolean;
  onPick: () => void;
}

const ThemeOption = (props: ThemeOptionProps) => {
  return (
    <li>
      <input onChange={props.onPick} type="radio" id={props.id} name="theme" value={props.value} defaultChecked={props.checked} />
      <label htmlFor={props.id}>
        <div className="theme-option-bg"></div>
        <div className="color-circle"></div>
      </label>
    </li>
  );
};

const scrollStyles = {
  margin: '12px 4px',
  padding: '10px',
  fontSize: '14px',
  borderRadius: '20px',
  border: 'none',
  width: '30%',
  fontFamily: 'sans-serif',
};


const ThemeMenu = (props: ThemeMenuProps) => {
  const [isLive, setisLive] = useState(false);
  const [screen, setscreen] = useState('nf');
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const mode = urlParams.get('mode');
    if (mode === 'live') {
      setisLive(true);
    }
  }, []);
  
  const screenToggle = () => {
    const elem:any = document.documentElement;
    const docu:any = document;

    if(screen === 'f'){
        setscreen('nf');
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (docu.webkitExitFullscreen) { /* Safari */
            docu.webkitExitFullscreen();
        } else if (docu.msExitFullscreen) { /* IE11 */
            docu.msExitFullscreen();
        }
    } else {
        setscreen('f');
        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.webkitRequestFullscreen) { /* Safari */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE11 */
            elem.msRequestFullscreen();
        }
    }
  }

  return (
    <div className="theme-menu" onMouseEnter={props.onMouseEnter} onMouseLeave={props.onMouseLeave}>
      <div onClick={props.onClickHamburger} className="hamburger-icon">
        &#8226;
        <br />
        &#8226;
        <br />
        &#8226;
      </div>
      <div style={{ left: props.left + 'px' }} className="theme-menu-menu">
        <div className="theme-menu-container">
          <div className="theme-menu-trigger"></div>
          {!props.themeOnly && (
            <ActionLink className="edit-btn" href={props.edit_gallery_url}>
              Change Cover Image
            </ActionLink>
          )}
          {
            isLive && (<button className="fullscreen-btn" onClick={screenToggle} >
                {screen === 'nf' ? 'Enter Fullscreen' : 'Exit Fullscreen'}
              </button>)
          }
          {props.canChangeSpeed && isLive && (
            <>
              <h3>Select Your Stream Speed</h3>
              <button style={scrollStyles} className={styles['change-speed']} disabled={props.speed == 'slow'} onClick={props.onScrollSlow}>
                Slow
              </button>
              <button style={scrollStyles} className={styles['change-speed']} disabled={props.speed == 'medium'} onClick={props.onScrollMedium}>
                Medium
              </button>
              <button style={scrollStyles} className={styles['change-speed']} disabled={props.speed == 'fast'} onClick={props.onScrollFast}>
                Fast
              </button>
            </>
          )}

          <h3>Select Your Theme</h3>
          <ul>
            {_.map(options, ([id, value]) => {
              return <ThemeOption key={id} id={id} value={value} onPick={props.onPick(value)} checked={props.theme === value} />;
            })}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ThemeMenu;
